import { z } from "zod";
const attributesIconSchema = z.object({
  src: z.string(),
  "src-dark": z.string().optional(),
  title: z.string().optional(),
  class: z.string().optional(),
  size: z.string().optional()
});
export {
  attributesIconSchema
};
//# sourceMappingURL=attributes.js.map
